import axios from 'axios';

export default class HttpService {
  constructor() {
    this.ws = this._loadAxios();
  }

  _loadAxios(_responseType = "") {
    return axios.create({
      baseURL: process.env.VUE_APP_SALESFORCE_SERVICE_URL,
      headers: this._loadHeaders(),
      responseType: _responseType ? _responseType : null,
    });
  }

  _loadHeaders() {
    return {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'Access-Control-Max-Age': 600,
      'Cache-Control': 'max-age=600'
    }
  }

  get(path, params = null) {
    this.ws = this._loadAxios()
    return this.ws.get(path, {
      params: params,
    });
  }

  post(path, data) {
    return this.ws.post(path, data);
  }

  put(path, data) {
    return this.ws.put(path, data);
  }

  delete(path) {
    return this.ws.delete(path);
  }
}